<template>
  <v-multiselect
    v-model="fieldModelValue"
    label="email"
    track-by="id"
    :options="options"
    :disabled="!editable"
    :allow-empty="false" />
</template>
<script>
export default {
  name: 'DoctorInput',
  props: {
    value: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  data() {
    return {
      options: []
    };
  },
  beforeCreate() {
    this.axios.get('/admin/availabledoctors')
      .then((res) => {
        this.options = res.data.result;
        this.options.unshift({ id: 0, email: this.$t('common.None') });
      });
  },
  computed: {
    fieldModelValue: {
      get() {
        if (!this.value) this.$emit('input', 0);
        return (
          this.options.filter((x) => x.id === this.value)
          || this.options.filter((x) => x.id === 0)
        );
      },
      set(newValue) {
        this.$emit('input', newValue.id);
      }
    }
  },
  methods: {
    setDoctor(val) {
      this.fieldModelValue = this.options.find((x) => x.id === val);
    }
  }
};
</script>
<style lang="scss" scoped></style>
